import React from "react";
import StyledLgText from "../../common/components/styledLgText/StyledLgText.tsx";

const HomeCrousalCard = ({ heading, imgurl2 }) => {
  return (
    <div className="bg-white rounded-2xl self-stretch gap-5 flex flex-col items-start justify-between p-7 border border-gray-100 shadow-soft hover:shadow-card transition-all duration-300 h-full">
      <StyledLgText children={heading} fontColor={"text-lightBlack text-[16px] leading-relaxed font-normal"} />
      <div className="flex justify-start items-center gap-3 mt-2">
        <img src={imgurl2} alt="people" className="h-12 w-12 rounded-full object-cover ring-2 ring-gray-100" />
      </div>
    </div>
  );
};

export default HomeCrousalCard;
